// extracted by mini-css-extract-plugin
module.exports = {"splitSection":"homepage_splitSection__pbv4D","highlightVideoGrid":"homepage_highlightVideoGrid__N4yQY"};